import React from 'react';
import './Separator.css';

const Separator: React.FC = () => <div className="separator" />;

export default Separator;
